import { connect } from 'react-redux';
import { translate } from '../../base/i18n/functions';
import { IconVolumeUp } from '../../base/icons/svg';
import { isMobileBrowser } from '../../base/environment/utils';
import AbstractButton from '../../base/toolbox/components/AbstractButton';
import logger from '../logger';
/**
 * Plays a very brief near-silent tone through a new AudioContext.
 *
 * On Android Chrome, WebRTC's MODE_IN_COMMUNICATION can silently reroute
 * audio to the earpiece after focus changes (notifications, screen lock, etc.).
 * A user-gesture-triggered AudioContext play resets Chrome's audio routing
 * back to the loudspeaker.
 *
 * @returns {void}
 */
function _playSpeakerResetTone() {
    if (typeof AudioContext === 'undefined') {
        return;
    }
    let ctx = null;
    try {
        ctx = new AudioContext();
        const gain = ctx.createGain();
        gain.gain.value = 0.001;
        const osc = ctx.createOscillator();
        osc.type = 'sine';
        osc.frequency.value = 440;
        osc.connect(gain);
        gain.connect(ctx.destination);
        osc.start();
        osc.stop(ctx.currentTime + 0.15);
        osc.onended = () => {
            ctx?.close();
        };
    }
    catch (err) {
        logger.warn('Speaker reset tone failed', err);
        ctx?.close();
    }
}
/**
 * A toolbar button that forces audio routing back to the loudspeaker on
 * Android mobile browsers.
 *
 * This is shown only on Android because iOS Safari and desktop browsers either
 * handle routing automatically or have no relevant issue.
 */
class SpeakerToggleButton extends AbstractButton {
    accessibilityLabel = 'toolbar.accessibilityLabel.speakerToggle';
    icon = IconVolumeUp;
    label = 'toolbar.speakerToggle';
    tooltip = 'toolbar.speakerToggle';
    /**
     * Handles clicking / pressing the button.
     *
     * @private
     * @returns {void}
     */
    _handleClick() {
        _playSpeakerResetTone();
    }
}
/**
 * Maps (parts of) the Redux state to the component props.
 *
 * @returns {Object}
 */
function _mapStateToProps() {
    return {
        // Only render on Android and iOS mobile browsers.
        // Desktop browsers handle audio routing themselves.
        visible: isMobileBrowser()
    };
}
export default translate(connect(_mapStateToProps)(SpeakerToggleButton));
